import React from 'react'; // Import React
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const NotFound = () => {
    const { t } = useTranslation(); // Use useTranslation hook
    const navigate = useNavigate(); // Use useNavigate hook

    return (
        <div className="min-h-screen bg-slate-900 flex items-center justify-center">
            <div className="text-center">
                <h1 className="text-white text-6xl font-bold mb-4">404</h1>
                <p className="text-gray-400 text-xl mb-8">{t('Page not found')} {/* Use translation key */}</p>
                <button
                    onClick={() => navigate('/')}
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg transition-colors"
                >
                    {t('Go Home')} {/* Use translation key */}
                </button>
            </div>
        </div>
    );
};

export default NotFound; // Export the component